module.exports = __webpack_public_path__ + "img/kueskiPay.61e8b41d.png";